export default {
	data() {
		return {
			_windowResizeMixin: {
				bindedListener: null,
				waiting: false,
			},
		};
	},

	mounted() {
		this.$data._windowResizeMixin.bindedListener = this._windowResizeMixin_onWindowResize.bind(this);
		window.addEventListener('resize', this.$data._windowResizeMixin.bindedListener);
		// Event Listener on 'scroll' can cause some performance issues. So we are attaching it only while opening a select in AdvancedSelect.js
		this._windowResizeMixin_onWindowResize();
	},

	beforeUnmount() {
		window.removeEventListener('resize', this.$data._windowResizeMixin.bindedListener);
		window.removeEventListener('scroll', this.$data._windowResizeMixin.bindedListener);
	},

	methods: {
		_windowResizeMixin_onWindowResize(e) {
			if (!this.$data._windowResizeMixin.waiting) {
				this.$data._windowResizeMixin.waiting = true;

				this.$nextTick(() => {
					if (e == undefined || e.type == 'resize') {
						this.onWindowResize({
							width: window.innerWidth,
							height: window.innerHeight,
						});
					} else if (e.type == 'scroll') {
						this.onWindowScroll();
					}

					this.$data._windowResizeMixin.waiting = false;
				});
			}
		},

		onWindowResize() {},
		onWindowScroll() {},
	},
};
